module.exports = __webpack_public_path__ + "img/gsb26.648723ee.png";